import { observer } from 'mobx-react-lite';
import React from 'react';
import { TabPanel } from 'react-tabs';
import { colors } from '../../../../../../../../colorVars';
import { updatePlugins } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/updatePlugins';
import { useWebsocketStore } from '../../../../../../../../stores/websocketStore/websocketProvider';
import { MultiSwitch } from '../../../../../../../atomic/buttons/multiSwitch/MultiSwitch';
import { EditableTableField } from '../../../../../../../atomic/inputs/editableTableField/EditableTableField';
import { Body3 } from '../../../../../../../atomic/text/Text';
import { IndividualPanelHeader } from '../IndividualPanelHeader';
import style from '../IndividualTacticStyle.module.css';

export const PriceIntersectsFirstCandleTacticPanel = observer(
  // eslint-disable-next-line no-unused-vars
  ({ tradePlanId, addTab, ...rest }) => {
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId];

    const updateTactic = (field, newValue) => {
      updatePlugins(
        'setupFilter',
        { [field]: newValue },
        'PRICE_INTERSECTS_FIRST_CANDLE',
        tradePlanId,
        null
      );
    };
    if (!tradePlan?.setupFilters['PRICE_INTERSECTS_FIRST_CANDLE']) return null;

    return (
      <TabPanel {...rest}>
        <div className={style.tableContainer}>
          <table className={style.table}>
            <IndividualPanelHeader />
            <tbody>
              <tr>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Candle Barrier
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <MultiSwitch
                    labels={['High', 'Low']}
                    values={['HIGH', 'LOW']}
                    controlledValue={
                      tradePlan.setupFilters['PRICE_INTERSECTS_FIRST_CANDLE']
                        .candleBarrier
                    }
                    setValue={(value) => updateTactic('candleBarrier', value)}
                    margin="5px 0 0 0"
                  />
                </td>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Direction
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <MultiSwitch
                    labels={['Above', 'Below']}
                    values={['ABOVE', 'BELOW']}
                    controlledValue={
                      tradePlan.setupFilters['PRICE_INTERSECTS_FIRST_CANDLE']
                        .direction
                    }
                    setValue={(value) => updateTactic('direction', value)}
                    margin="5px 0 0 0"
                  />
                </td>
              </tr>
              <tr>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Candle Duration
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <EditableTableField
                    color={colors.lightGrey}
                    bodySize={3}
                    backgroundColor="inherit"
                    initialValue={
                      tradePlan.setupFilters['PRICE_INTERSECTS_FIRST_CANDLE']
                        .candleDuration
                    }
                    updateValue={(newValue) => {
                      if (
                        newValue !== 0 &&
                        newValue !==
                          tradePlan.setupFilters['PRICE_INTERSECTS_FIRST_CANDLE']
                            .candleDuration
                      )
                        updateTactic('candleDuration', newValue);
                    }}
                    inputType="number"
                  />
                </td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </TabPanel>
    );
  }
);

PriceIntersectsFirstCandleTacticPanel.tabsRole = 'TabPanel';
